import React from "react";
import { NotificationManager } from "react-notifications";
import { useForm } from "react-hook-form";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { useDebouncedAsyncSelect } from "../../../../../../Utils/Hooks/useDebounce";

export const FormIdRecepcion = ({ bultosSkimApi, RefreshData }) => {
    // formulario
    const {
        control: formControl,
        register: formRegister,
        formState: { errors: formErrors },
        getValues: formGetValues,
        setValue: formSetValue,
        watch,
        trigger: validateForm,
    } = useForm({
        mode: "onChange",
    });

    const { agregarBultoSkim, getAlmacenesSkim } = bultosSkimApi;

    const AgregarBulto = async () => {
        try {
            const isValid = await validateForm();
            if (!isValid) {
                return;
            }

            const recepcion_id = formGetValues("recepcion_id");

            const data = {
                recepcion: recepcion_id,
            };
            await agregarBultoSkim(data);

            NotificationManager.success(
                "Bulto agregado correctamente",
                "Éxito",
                3000,
            );

            // Limpiar campos del formulario
            formSetValue("recepcion_id", null);

            RefreshData();
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al agregar bulto skim",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const fechaFinal = watch("fecha_final");

    const loadAlmacenes = useDebouncedAsyncSelect(function (search) {
        return getAlmacenesSkim({ search: search });
    });

    return (
        <div className="formulario-fields-row">
            <div
                className="formulario-field mr-1"
                style={{ flex: 2.1, minWidth: "500px" }}
            >
                <label className="text-nowrap">ID de Recepción</label>
                <input
                    type="text"
                    {...formRegister("recepcion_id", {
                        required: "Este campo es obligatorio",
                    })}
                    className="form-control"
                />
                {formErrors.recepcion_id && (
                    <small className="text-danger">
                        {formErrors.recepcion_id.message}
                    </small>
                )}
            </div>

            <div className="formulario-field" style={{ minWidth: "33%" }}>
                <button
                    className="btn btn-primary"
                    style={{ marginTop: "26px" }}
                    onClick={AgregarBulto}
                >
                    Agregar por ID
                </button>
            </div>
        </div>
    );
};
